import { render, staticRenderFns } from "./solveQueastion.vue?vue&type=template&id=51a06d9d&scoped=true&"
import script from "./solveQueastion.vue?vue&type=script&lang=js&"
export * from "./solveQueastion.vue?vue&type=script&lang=js&"
import style0 from "./solveQueastion.vue?vue&type=style&index=0&id=51a06d9d&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51a06d9d",
  null
  
)

export default component.exports